import styled from 'styled-components';

const FieldColumn = styled.div`
  margin-bottom: 1rem;
`
export default FieldColumn;